const conf = {
  // Password for new users
  predefinedPassword: ['hello', 'afamiliarmaterial'],
  locations: {
    0: { id: 0, title: 'Anywhere' },
    1: { id: 1, title: 'Home' },
    2: { id: 2, title: 'Cafe' },
    3: { id: 3, title: 'Thoroughfare' },
    4: { id: 4, title: 'Clock' },
    5: { id: 5, title: 'Bridge' },
    6: { id: 6, title: 'Vantage' }
  },
  episodes: {
    4: {
      id: 4,
      title: 'Epilogue',
      chapterCount: 1,
      chapters: {
        1: {
          id: 1,
          location: 0,
          storyCount: 1,
          titles: {
            1: 'Hands'
          }
        }
      }
    },
    3: {
      id: 3,
      title: 'Transition',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 2,
          storyCount: 1,
          titles: {
            1: 'It Happened Here'
          }
        },
        2: {
          id: 2,
          location: 6,
          storyCount: 1,
          titles: {
            1: 'There Will Be One'
          }
        },
        3: {
          id: 3,
          location: 3,
          storyCount: 1,
          titles: {
            1: 'Wait'
          }
        },
        4: {
          id: 4,
          location: 4,
          storyCount: 1,
          titles: {
            1: 'Search'
          }
        },
        5: {
          id: 5,
          location: 1,
          storyCount: 1,
          titles: {
            1: 'Mothwings'
          }
        }
      }
    },
    2: {
      id: 2,
      title: 'Thread',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 1,
          storyCount: 3,
          titles: {
            1: 'An Old Place',
            2: 'A Different Sky',
            3: 'Ripples'
          }
        },
        2: {
          id: 2,
          location: 5,
          storyCount: 3,
          titles: {
            1: 'Gaps In The Pages',
            2: 'Against The Flow',
            3: 'Actual Memories'
          }
        },
        3: {
          id: 3,
          location: 2,
          storyCount: 3,
          titles: {
            1: 'Black Erasing Fluid',
            2: 'A Door Slams Shut',
            3: 'This Is Not My City'
          }
        },
        4: {
          id: 4,
          location: 6,
          storyCount: 4,
          titles: {
            1: 'Upward Into The Sky',
            2: 'Blank Page',
            3: 'If This Was My City',
            4: 'An Orrery'
          }
        },
        5: {
          id: 5,
          location: 5,
          storyCount: 4,
          titles: {
            1: 'Say the Lament',
            2: 'Waiting For A Noise',
            3: 'I Can See The Tide Rise',
            4: 'I Stood By The Wharf'
          }
        }
      }
    },
    1: {
      id: 1,
      title: 'Assemble',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 1,
          storyCount: 3,
          titles: {
            1: 'Let His Mistake Go',
            2: 'Remember',
            3: 'Dear Suzie'
          }
        },
        2: {
          id: 2,
          location: 2,
          storyCount: 4,
          titles: {
            1: 'Between',
            2: 'Bursting',
            3: 'My Father',
            4: 'Tattoo'
          }
        },
        3: {
          id: 3,
          location: 5,
          storyCount: 3,
          titles: {
            1: 'Blink',
            2: 'Let Go',
            3: 'Carry Me'
          }
        },
        4: {
          id: 4,
          location: 4,
          storyCount: 4,
          titles: {
            1: 'I Write You',
            2: 'Ink',
            3: 'Marks',
            4: 'Can I Be That Blind'
          }
        },
        5: {
          id: 5,
          location: 3,
          storyCount: 4,
          titles: {
            1: 'The Girl',
            2: 'Out Of The Water',
            3: 'To Actually Feel',
            4: 'Attend To Today'
          }
        }
      }
    }
  },
  initialProgress: {
    episode: '1',
    chapter: '1',
    number_of_stories: 0,
    welcome: true,
    finished: false,
    episode_interval: 60,
    debug: false,
    fades: ['']
  }
}
export default conf
